import React from 'react'
import { Router } from 'react-static'
import { hot } from 'react-hot-loader'
import Routes from 'react-static-routes'

import 'containers/app.scss'

const App = () => (
    <Router>
        <div>
            <div className='content'>
                <Routes/>
            </div>
        </div>
    </Router>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// /usr/src/site-blog/src/App.jsx